const e = "_link_4xee8_1", n = "_external_4xee8_19", t = {
  link: e,
  external: n
};
export {
  t as default,
  n as external,
  e as link
};
//# sourceMappingURL=link.module.less.js.map
